


const Spinner = () => {
    return (
        <>
            {/* <div className="page-loader">
                <div className="spinner-border text-primary"></div>
                <span className="text-primary">در حال بارگذاری ...</span>
            </div> */}
            <div className="page-loader" style={{ background: "#ffffffa3",zIndex:"1111111" }}>
                <div className="spinner-border text-primary"></div>
                <span>در حال بارگذاری ...</span>
            </div>
        </>
    );
}

export default Spinner;